import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "c433d5cf-0cdd-46c8-bd05-860397176d46", content: "Fairly close to the player, in front.", options: {} },
  { id: "599ca438-d88f-4b70-8578-0c47fc0c681b", content: "Fairly close to the player, to the side.", options: {} },
  { id: "68893a3b-64a3-488d-8ebe-dcda41dd1c83", content: "Fairly close to the player, behind.", options: {} },
  { id: "0e0ea3af-cfa7-415c-9f6e-7ab20634c647", content: "Very close to the player, in front.", options: {} },
  { id: "566e534c-0c47-4a76-aed8-5192b850ff03", content: "Very close to the player, to the side.", options: {} },
  { id: "ad62931a-e129-4b8e-bb1b-0be3b569c533", content: "Very close to the player, behind.", options: {} },
  { id: "f2146f0b-b078-474d-be09-aa2321125a02", content: "Somewhere far away from the player.", options: {} },
];

export const task: Task = {
  id: "27fcedbb-97b6-4ae0-ba94-63eff78aa273",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["0e0ea3af-cfa7-415c-9f6e-7ab20634c647"],
};
